import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "variantSourceSelect"]

  open() {
    this.dialogTarget.classList.remove("hidden")
  }

  close() {
    this.dialogTarget.classList.add("hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.dialogTarget.classList.add("hidden")
    }
  }

  closeOnSuccess(event) {
    if (event.detail.success) {
      this.close()
    }
  }

  toggleVariantSource(event) {
    if (this.hasVariantSourceSelectTarget) {
      this.variantSourceSelectTarget.classList.toggle("hidden", event.target.value !== "variant")
    }
  }
}
